import {Component, forwardRef} from "@angular/core";
import {SelectOptionsComponent} from "../../../framework/entity/select/options/select-options.component";
import {TranslateService} from "@ngx-translate/core";
import {KvdDocketButtonType} from "../order-processor.data";

@Component({
    selector: "wbo-kvd-docket-button-type-select-options",
    templateUrl: "./kvd-docket-button-type-select-options.component.html",
    providers: [{
        provide: SelectOptionsComponent,
        useExisting: forwardRef(() => KvdDocketButtonTypeSelectOptionsComponent),
        multi: true
    }]
})
export class KvdDocketButtonTypeSelectOptionsComponent extends SelectOptionsComponent {
    KvdDocketButtonType = KvdDocketButtonType;

    constructor(translateService: TranslateService) {
        super(translateService);
    }
}
